import(/* webpackMode: "eager" */ "/home/test_user/npc_front/out/websitenextjs/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/test_user/npc_front/out/websitenextjs/components/AnalyticsProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/test_user/npc_front/out/websitenextjs/layout/Navbar.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/test_user/npc_front/out/websitenextjs/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/test_user/npc_front/out/websitenextjs/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/test_user/npc_front/out/websitenextjs/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/test_user/npc_front/out/websitenextjs/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/home/test_user/npc_front/out/websitenextjs/styles/stylesheet.css");
